import { render, staticRenderFns } from "./UsuariosFormulario.vue?vue&type=template&id=257c22d1&"
import script from "./UsuariosFormulario.vue?vue&type=script&lang=ts&"
export * from "./UsuariosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports